// extracted by mini-css-extract-plugin
export default {"page-end":"BuHelpForm-cx32D__page-end","open-help-form":"BuHelpForm-gA0v0__open-help-form","help-back":"BuHelpForm-F7gY2__help-back"};